export default __webpack_public_path__ + "static/media/27.a8ee4561.png";